'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = function (app) {
  app.factory('selectModal', function ($rootScope, $timeout, $filter, $sce, baseModal) {

    /**
     * default props
     */
    var props = {
      /**
       * header 标题
       */
      title: {
        type: String,
        default: '选择'
      },
      /**
       * 内容覆盖整个视窗 默认为true
       */
      fullScreen: {
        type: Boolean,
        default: true
      },
      /**
       * 是否显示搜索框 默认为false
       */
      hasSearch: {
        type: Boolean,
        default: false
      },
      /**
       * 是否显示重置按钮 默认为 true
       */
      hasReset: {
        type: Boolean,
        default: true
      },
      /**
       * 搜索框占位符文本 默认为'搜索'
       */
      searchPlaceholder: {
        type: String,
        default: '搜索'
      },
      /**
       * modal视图样式 配合fullScreen使用 默认为空 即不做设置
       */
      modalViewStyle: {
        type: Object,
        default: null
      },
      /**
       *  背景颜色灰色透明 默认为false 当fullScreen为false时 值为true
       */
      backdropTransparentGray: {
        type: Boolean,
        default: false
      },
      /**
       * 取消操作的按钮名称 默认为'返回'
       */
      cancelButtonName: {
        type: String,
        default: '返回'
      },
      /**
       * 重置操作的按钮名称 默认为'重置'
       */
      resetButtonName: {
        type: String,
        default: '重置'
      },
      /**
       * 没有搜索到结果的文本提示 默认为'暂无数据...'
       */
      noResultsMessage: {
        type: String,
        default: '暂无数据...'
      },
      /**
       * value 字段
       */
      displayValue: {
        type: String,
        default: 'value'
      },
      /**
       * text 字段
       */
      displayText: {
        type: String,
        default: 'text'
      },
      /**
       * 数据源 预先定义好的一个 嵌套结构的数组
       */
      datasource: {
        type: Array,
        default: []
      },
      /**
       * 数据源 如果是异步获取 接收一个promise对象
       */
      loadDatasource: {
        type: Function,
        default: null
      },
      /**
       * item 自定义模板渲染
       */
      itemRender: {
        type: Function,
        default: null
      },
      /**
       * 对数据源进行过滤
       */
      filter: {
        type: Function,
        default: null
      },
      /**
       * 事件 选项改变后触发
       */
      onChange: {
        type: Function,
        default: null
      },
      /**
       * 事件 点击重置后触发
       */
      onReset: {
        type: Function,
        default: null
      }
    };

    /**
     * 加载数据
     */
    function loadDatasource(scope, options) {
      scope.loading = true;
      scope.errorMessage = '';
      if ((0, _objectType.isFunction)(options.loadDatasource)) {
        $timeout(function () {
          options.loadDatasource({
            done: function done(data) {
              scope.loaded = true;
              scope.errorMessage = '';
              options.datasource = data;
              refreshDatasource(scope, options);
            },
            failed: function failed(errorMessage) {
              scope.loaded = false;
              scope.errorMessage = errorMessage || '加载失败';
              scope.loading = false;
            }
          });
        }, 500);
      } else {
        scope.loaded = true;
        refreshDatasource(scope, options);
      }
    }

    /**
     * 刷新数据
     */
    function refreshDatasource(scope, options) {
      scope.loading = true;

      // 外部自定义过滤
      var datasource = [];
      if ((0, _objectType.isFunction)(options.filter)) {
        datasource = options.filter(options.datasource);
      } else {
        datasource = options.datasource;
      }

      // 过滤搜索关键字
      if (scope.search.input) {
        datasource = $filter('filter')(datasource, (0, _defineProperty3.default)({}, options.displayText, scope.search.input));
      }

      renderDatasource(scope, datasource);

      $timeout(function () {
        scope.loading = false;
      }, 100);
    }

    /**
     * 渲染数据
     */
    function renderDatasource(scope, datasource) {
      scope.datasource = datasource;
    }

    /**
     * 创建 options
     */
    function createOptions(options) {
      var _this = this,
          _options = {};

      (0, _forEach2.default)(props, function (value, key) {
        _options[key] = value.default;
      });

      _this.updateOptions = function (options) {
        if ((0, _objectType.isObject)(options)) {
          (0, _forEach2.default)(options, function (value, key) {
            if (props.hasOwnProperty(key)) {
              if (!(0, _objectType.isNullOrUndefined)(value)) {
                if (value.constructor === props[key].type) {
                  _options[key] = value;
                } else {
                  throw 'Invalid prop: type check failed for prop "' + key + '". Expected ' + props[key].type.name + ', got ' + value.constructor.name + '.';
                }
              }
            }
          });
        }
        return _options;
      };

      return _this.updateOptions(options);
    }

    /**
     * 创建 scope
     */
    function createScope(scope, options) {
      var _this = this;
      scope = scope && scope.$new() || $rootScope.$new(true);

      // 设置一个变量 判断是否数据是否加载完成
      scope.loaded = false;

      (0, _extend2.default)(scope, {
        title: options.title,
        hasSearch: options.hasSearch,
        cancelButtonName: options.cancelButtonName,
        resetButtonName: options.resetButtonName,
        errorMessage: '',
        loading: true,
        noResultsMessage: options.noResultsMessage,
        datasource: [],
        datasourceTemplate: ''
      });

      // 关键字过滤
      scope.search = {
        input: '',
        focus: false,
        placeholder: options.searchPlaceholder,
        clear: function clear() {
          scope.search.input = '';
          $timeout(function () {
            scope.search.focus = true;
          });
        }
      };
      if (options.hasSearch) {
        scope.$watch('search.input', (0, _debounce2.default)(function (newValue, oldValue) {
          if (newValue !== oldValue) {
            refreshDatasource(scope, options);
          } else {
            scope.loading = false;
          }
        }, 300, false, function () {
          scope.loading = true;
        }));
      }

      // 渲染item
      scope.hasCustomRender = !!options.itemRender;
      if (scope.hasCustomRender) {
        scope.itemRender = function (item) {
          var html = options.itemRender(item);
          return $sce.trustAsHtml(html);
        };
      } else {
        scope.itemRender = function (item) {
          return item[options.displayText];
        };
      }

      // 点击item
      scope.itemClick = function (item) {
        if ((0, _objectType.isFunction)(options.onChange)) {
          options.onChange(item);
        }
        _this.hide();
      };

      // 重新加载
      scope.reload = function () {
        if (!scope.loading) {
          loadDatasource(scope, options);
        }
      };

      // 返回
      scope.back = function () {
        _this.hide();
      };

      // 重置
      scope.reset = function () {
        if ((0, _objectType.isFunction)(options.onReset)) {
          options.onReset(null);
        }
        if (options.hasSearch) {
          scope.search.input = '';
        }
        _this.hide();
      };

      // 销毁实例
      scope.$on('$destroy', function () {
        _this.remove();
        _this = null;
        scope = null;
      });

      return scope;
    }

    /**
     * 创建baseModal实例
     */
    function createModal(scope, options) {
      return baseModal.fromTemplate(scope, {
        slideDirection: 'up',
        fullScreen: options.fullScreen,
        modalViewStyle: options.modalViewStyle,
        backdropTransparentGray: options.backdropTransparentGray,
        modalViewClassName: 'select-modal'
      }, require('./selectModal.html'));
    }

    function SelectModal(scope, options) {

      var self = this;

      var _options = createOptions.call(self, options);

      var _scope = createScope.call(self, scope, _options);

      var _modal = createModal(_scope, _options);

      /**
       * 提供外部一个接口 手动加载数据 该加载动作会在下一次显示modal的时候 执行
       */
      self.reload = function () {
        _scope.loaded = false;
      };

      /**
       * 提供外部一个接口 手动刷新数据 该刷新动作会在下一次显示modal的时候 执行
       */
      self.refresh = function () {
        _scope.loading = true;
      };

      /**
       * 显示 modal
       */
      self.show = function (options) {
        if (options) {
          this.updateOptions({
            title: options.title,
            filter: options.filter,
            onChange: options.onChange,
            onReset: options.onReset
          });
        }
        return _modal.show().then(function () {
          _scope.$evalAsync(function () {
            if (!_scope.loaded) {
              loadDatasource(_scope, _options);
            } else if (_scope.loading) {
              refreshDatasource(_scope, _options);
            }
          });
        });
      };

      /**
       * 重置选项
       */
      self.reset = function () {
        _scope.reset();
      };

      /**
       * 隐藏 modal
       */
      self.hide = function () {
        return _modal.hide();
      };

      /**
       * 从dom中删除 modal
       */
      self.remove = function () {
        return _modal.remove();
      };

      return self;
    }

    return function (scope, options) {
      return new SelectModal(scope, options);
    };
  });
  return app;
};

require('angular');

require('ionic');

require('./selectModal.scss');

var _extend = require('../../../utils/extend');

var _extend2 = _interopRequireDefault(_extend);

var _debounce = require('../../../utils/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _forEach = require('../../../utils/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _objectType = require('../../../utils/objectType');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 下拉列表 用modal模拟
 *
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/services/selectModal/index.js
// module id = 165
// module chunks = 0